const config = {
  AUTH_URL: "https://reckon-api-auth-per-qa.reckon.ai/app",
  DNS: "buybye.reckon.ai",
  DNS_APP: "spar.buybye.app",
  BUYBYE_URL: "https://buybye-testing-qr.reckon.ai",
  PAYMENT_SYSTEM: "payOne",
};

export default config;
